import React from 'react';

import { Route, Switch } from 'react-router';

import ErrorScreen from 'components/shared/ErrorScreen';
import Loader from 'components/shared/Loader';

import ForgotPassword from '../GuestPortal/Auth/ForgotPassword';
import AuthContainerLayout from '../GuestPortal/Auth/Layout';
import ResetPassword from '../GuestPortal/Auth/ResetPassword';
import SignIn from '../GuestPortal/Auth/SignIn';
import { useGetPrimaryImageUrl } from '../GuestPortal/functions';
import {
  GP_AUTH_FORGOT_ROUTE,
  GP_AUTH_RESET_ROUTE,
  GP_AUTH_SIGNIN_ROUTE,
  GP_AUTH_SIGNUP_ROUTE,
  GP_AUTH_VERIFY_ACCOUNT_ROUTE,
  GP_AUTH_VERIFY_ROUTE,
  GP_LOOKUP,
} from '../GuestPortal/Routes/constants';
import LookUp from './Auth/LookUp';
import SendVerification from './Auth/SendVerification';
import VerificationPage from './Auth/VerificationPage';
import { useAuthLoader } from './functions';

function AuthRoutesAccessFlow() {
  const { data, isLoading, error } = useAuthLoader();
  const { primaryUrl } = useGetPrimaryImageUrl(data);

  if (error) {
    return <ErrorScreen status="404_guest" />;
  }

  if (isLoading) {
    return <Loader isFillBlock />;
  }

  return (
    <AuthContainerLayout bgImage={primaryUrl}>
      <Switch>
        <Route path={GP_AUTH_SIGNIN_ROUTE}>
          <SignIn />
        </Route>
        <Route path={GP_AUTH_SIGNUP_ROUTE}>
          <div>Sign up</div>
        </Route>
        <Route path={GP_LOOKUP}>
          <LookUp />
        </Route>
        <Route path={GP_AUTH_VERIFY_ROUTE}>
          <SendVerification />
        </Route>
        <Route path={GP_AUTH_VERIFY_ACCOUNT_ROUTE}>
          <VerificationPage />
        </Route>
        <Route path={GP_AUTH_FORGOT_ROUTE}>
          <ForgotPassword />
        </Route>
        <Route path={GP_AUTH_RESET_ROUTE}>
          <ResetPassword />
        </Route>

        <Route>
          <ErrorScreen status="404_guest" />
        </Route>
      </Switch>
    </AuthContainerLayout>
  );
}

export default AuthRoutesAccessFlow;
